import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ComfortFeatures.module.css';

function ComfortFeatures() {
  const { t } = useTranslation();
  const baseUrl = process.env.PUBLIC_URL || '';
  const features = [
    t('comfort.feature1'),
    t('comfort.feature2'),
    t('comfort.feature3'),
    t('comfort.feature4'),
    t('comfort.feature5'),
    t('comfort.feature6'),
  ];

  return (
    <section
      id="comfort"
      className={styles.section}
      style={{ backgroundImage: `url(${baseUrl || ''}/comfort-bg.png)` }}
    >
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h2 className={styles.heading}>{t('comfort.heading')}</h2>
        <p className={styles.subheading}>{t('comfort.subheading')}</p>
        <p className={styles.description}>
          {t('comfort.description')}
        </p>
        <ul className={styles.list}>
          {features.map((item, i) => (
            <li key={i}>
              <span className={styles.check}>✓</span>
              {item}
            </li>
          ))}
        </ul>
        <p className={styles.closing}>
          {t('comfort.closing')}
        </p>
      </div>
    </section>
  );
}

export default ComfortFeatures;
